import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import { useViewport } from 'hooks/3catinfo/useViewport';
import Imatge from 'components/3catinfo/Imatge';
import Boto from 'components/3catinfo/Boto';
import BotoSeguir from 'components/3catinfo/BotoSeguir';
import { hitAudiencies } from 'components/3catinfo/Audiencies/audiencies-datalayer';
import CercaMunicipi from '../CercaMunicipi';
import styles from './modulDestacatVisual.module.scss';
import CercadorEleccions from '../Eleccions/CercadorEleccions';

const ModulDestacatVisual = (props) => {
    const { titol, estils, subtitol, boto, background, image, icon, cercador, numColumnsRow, isIframe = false } = props;
    const {
        color: colorBackground = 'none',
        image: imatgeBackground = {},
        opacity: opacityBackground = 1,
        border: borderBackground = 'none'
    } = background || {};

    const { isMobile } = useViewport();
    const isMobileLayout = isMobile || numColumnsRow <= 6;

    let Tag = titol?.tag;
    if (__isEmpty(Tag)) Tag = 'h2';

    const styleVarsBackground = {
        '--bg-color': colorBackground || 'none',
        '--bg-imatge': imatgeBackground?.url ? `url(${imatgeBackground.url})` : 'none',
        '--bg-imatge-position': imatgeBackground?.position || 'center',
        '--bg-opacity': opacityBackground || 1,
        '--bg-border': borderBackground || 'none'
    };

    const stylesVarsIcon = {
        '--icon-gap': icon?.gap && `var(${icon?.gap})`,
        '--header-icon-width': icon?.width
    };

    const stylesVarsTitol = {
        '--text-titol-color': titol?.color,
        '--text-titol-fontSize': titol?.fontSize && `var(${titol?.fontSize})`,
        '--text-titol-lineHeight': titol?.lineHeight && `var(${titol?.lineHeight})`,
        '--text-titol-fontWeight': titol?.fontWeight
    };
    const stylesVarsSubtitol = {
        '--text-subtitol-color': subtitol?.color,
        '--text-subtitol-fontSize': subtitol?.fontSize && `var(${subtitol?.fontSize})`,
        '--text-subtitol-lineHeight': subtitol?.lineHeight && `var(${subtitol?.lineHeight})`,
        '--text-subtitol-fontWeight': subtitol?.fontWeight
    };

    const arrayEstils = estils?.split(' ') || [];
    const stylesWrrapper = clsx({
        [styles.wrapper]: true,
        [styles.imageLeft]: image?.position === 'left',
        [styles.noImatge]: __isEmpty(image),
        [styles.mobileLayout]: isMobileLayout,
        [styles.imageMobileTop]: image?.positionMobile === 'top',
        [styles.imageMobileBottom]: image?.positionMobile === 'bottom',
        ...arrayEstils.reduce((acc, currentStyle) => {
            acc[styles[currentStyle]] = !__isEmpty(currentStyle);
            return acc;
        }, {})
    });

    const stylesContent = clsx({
        [styles.content]: true,
        [styles.botoRight]: boto?.container === 'right' && !image
    });

    const arrayEstilsIcona = icon?.estils?.split(' ') || [];
    const stylesIcona = clsx({
        [styles.icona]: true,
        ...arrayEstilsIcona.reduce((acc, currentStyle) => {
            acc[styles[currentStyle]] = !__isEmpty(currentStyle);
            return acc;
        }, {})
    });
    const stylesHeader = clsx({
        [styles.header]: true,
        [styles.iconLeft]: icon?.position === 'left',
        [styles.iconMobileLeft]: icon?.positionMobile === 'left'
    });

    const iconWidth = isMobile ? icon?.widthMobile || icon?.width : icon?.width;
    const iconHeight = isMobile
        ? icon?.heightMobile || icon?.widthMobile || icon?.height || icon?.width
        : icon?.height || icon?.width;
    return (
        <article className={stylesWrrapper} style={styleVarsBackground}>
            <div className={styles.contentInfo}>
                <div className={styles.innerWrapper}>
                    <div className={stylesContent}>
                        {(icon || titol?.text || subtitol?.text) && (
                            <div className={stylesHeader} style={stylesVarsIcon}>
                                {icon && (
                                    <div className={stylesIcona}>
                                        <Imatge src={icon?.url} width={`${iconWidth}`} height={`${iconHeight}`} />
                                    </div>
                                )}
                                <div className={styles.textWrapper}>
                                    {titol?.text && (
                                        <Tag style={stylesVarsTitol} dangerouslySetInnerHTML={{ __html: titol?.text }} />
                                    )}
                                    {subtitol?.text && (
                                        <p
                                            className={styles.subtitol}
                                            style={stylesVarsSubtitol}
                                            dangerouslySetInnerHTML={{ __html: subtitol?.text }}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                        {cercador && (
                            <div className={styles.cercador}>
                                {cercador.tipus === 'eleccions' ? (
                                    <CercadorEleccions items={cercador.items} placeholder={cercador.placeholder} />
                                ) : (
                                    <CercaMunicipi
                                        placeholder={cercador.placeholder}
                                        routePath={cercador.routePath}
                                        getTitle={(item) => `${item.nom}`}
                                        municipisList={cercador.items}
                                        estil={cercador.estils}
                                        mostrarDesplegable={!isIframe}
                                        isIframe={isIframe}
                                    />
                                )}
                            </div>
                        )}
                        <BotoBlock boto={boto} titol={titol} />
                    </div>
                </div>
            </div>
            <ImatgeBlock image={image} isMobileLayout={isMobileLayout} />
        </article>
    );
};

const ImatgeBlock = ({ image, isMobileLayout }) => {
    if (!image) return null;

    const { percent = 40, aspectRatio = 'none', aspectRatioMobile = 'none', estils, url, urlMobile } = image;

    const imatge = isMobileLayout ? urlMobile : url;
    if (!imatge) return null;

    const styleVarsImatge = {
        '--imatge-width': `${percent}%`,
        '--imatge-aspectratio': aspectRatio,
        '--imatge-aspectratio-mobile': aspectRatioMobile
    };

    const arrayEstils = estils?.split(' ') || [];

    const stylesImage = clsx({
        [styles.wrapperImg]: true,
        ...arrayEstils.reduce((acc, currentStyle) => {
            if (!__isEmpty(currentStyle)) {
                acc[styles[currentStyle]] = true;
            }
            return acc;
        }, {})
    });

    return (
        <div className={stylesImage} style={styleVarsImatge}>
            <Imatge
                src={imatge}
                layout='fill'
                className={styles.bg}
                mostrarRecursTitol={false}
                objectFit='cover'
                alt=''
                objectPosition='left center'
            />
        </div>
    );
};

const BotoBlock = ({ boto, titol }) => {
    if (!boto) return null;

    const handleClick = () => {
        if (__isEmpty(boto?.audiencies)) return;

        const rawEvent = boto.audiencies?.event;
        const event = typeof rawEvent === 'string' && /^[A-Za-z][A-Za-z0-9]*$/.test(rawEvent) ? rawEvent : 'scClicBoto';
        const { event: _event, identificadorClic, ...restAudiencies } = boto.audiencies;
        hitAudiencies(event, {
            URL: window.location.href,
            identificadorClic: identificadorClic || boto.text,
            ...restAudiencies
        });
    };

    const styleVarsBoto = {
        '--btn-position': boto?.position,
        '--btn-text-color': boto?.textColor,
        '--btn-background-color': boto?.backgroundColor,
        '--btn-border-color': boto?.borderColor,
        '--btn-text-color-hover': boto?.textColorHover,
        '--btn-background-color-hover': boto?.backgroundColorHover,
        '--btn-border-color-hover': boto?.borderColorHover,
        '--btn-text-fontSize': boto?.fontSize && `var(${boto?.fontSize})`,
        '--btn-text-lineHeight': boto?.lineHeight && `var(${boto?.lineHeight})`,
        '--btn-text-fontWeight': boto?.fontWeight
    };

    const arrayEstilsBoto = boto?.estils?.split(' ') || [];

    const stylesBoto = clsx({
        [styles.boto]: true,
        ...arrayEstilsBoto.reduce((acc, currentStyle) => {
            if (!__isEmpty(currentStyle)) {
                acc[styles[currentStyle]] = true;
            }
            return acc;
        }, {})
    });

    const route = {
        type: boto?.type,
        slug: boto?.slug,
        slug2: boto?.slug2,
        href: boto?.href || boto?.url
    };

    if (boto?.action) {
        const tipologia =
            boto.action === 'seguirAutor' ? 'NOT_AUTOR' : boto.action === 'seguirNoticia' ? 'NOT_NOTICIA' : 'DTY_CATEGORY';

        return (
            <div className={styles.contentBoto}>
                <BotoSeguir
                    obreEsquerra={false}
                    id={boto.actionId}
                    textHitAudiencies={titol?.text}
                    tipologia={tipologia}
                    estil='petit'
                    enviaApi
                />
            </div>
        );
    }

    return (
        <div className={styles.contentBoto} style={styleVarsBoto}>
            <Boto
                key={`boto-modul-visual-${boto.id}`}
                link={boto.href || boto.url}
                route={route}
                className={stylesBoto}
                text={boto.text}
                icona={boto.icon?.name}
                isIconaBlanc={boto.icon?.iconaBlanc}
                isIconaDreta={boto.icon?.iconaDreta}
                iconaInline={boto.icon?.iconaInline}
                novaFinestra={boto.novaFinestra}
                altIcona={boto.text}
                dataTestId='boto-destacat-visual'
                fons={boto.fons}
                onClick={handleClick}
                estil={boto.estilBoto || 'noEstil'}
            />
        </div>
    );
};

export default ModulDestacatVisual;
